//main.js

$(document).foundation();

$(function() {

    var cookie = Cookies.get('locale');

    if (!cookie) {
        $('#language-chooser').fadeIn(); 
    }

    $(document).on('click','.language-close', function(e) {
        e.preventDefault();
        $('#language-chooser').fadeOut();
        Cookies.set('locale', site.locale, { expires: 365 });
    });

    $(document).on('click','.language-change', function(e) {
        var locale = $(this).attr('data-locale');
        Cookies.set('locale', locale);
        return true;
    });

    $('#slider_images').slick({
        dots: false,
        arrows: false,
        infinite: true,
        speed: 800,
        fade: true,
        autoplay: true,
        pauseOnHover: false,
        cssEase: 'linear',
        responsive: [
            {
                breakpoint: 640,
                settings: {
                    slidesToShow: 1
                }
            },
            {
                breakpoint: 480,
                settings: "unslick"
            }
        ]
    });

});
